import { useEffect } from 'react';

/**
 * Hook to set canonical tag for current page
 * Ensures all pages point to the preferred non-www .com.au domain
 */
export function useCanonicalTag(path: string) {
  useEffect(() => {
    const canonicalUrl = `https://theperthbookkeeper.com.au${path}`;
    
    // Update or create canonical tag
    let existingCanonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
    if (!existingCanonical) {
      existingCanonical = document.createElement('link') as HTMLLinkElement;
      existingCanonical.rel = 'canonical';
      document.head.appendChild(existingCanonical);
    }
    
    // Update href
    existingCanonical.href = canonicalUrl;
    
    return () => {
      // Cleanup on unmount (optional)
    };
  }, [path]);
}
